import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';

import shape from './images/shape.svg';

import styles from './install-diagram.module.scss';

const cx = classNames.bind(styles);

const InstallDiagram = ({
  className: classNameAdditional = '',
  title,
  buttontext = null,
  buttonurl = null,
  buttondescription = null,
}) => {
  const { illustration } = useStaticQuery(graphql`
    query {
      illustration: file(relativePath: { eq: "shared/install-diagram/illustration.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1220)
        }
      }
    }
  `);

  return (
    <section className={cx('wrapper', classNameAdditional)}>
      <div className="container">
        <Heading className={cx('title')} tag="h2" size="xl" innerHTML={title} />

        <div className={cx('illustration')} aria-hidden>
          <div className={cx('illustration-inner')}>
            <img className={cx('shape')} src={shape} alt="" loading="lazy" />
            <GatsbyImage image={getImage(illustration)} alt="" />
          </div>
        </div>

        {buttontext && buttonurl && (
          <>
            <Button className={cx('button')} to={buttonurl} size="md" theme="accent-primary">
              {buttontext}
            </Button>

            {buttondescription && (
              <span className={cx('button-description')}>{buttondescription}</span>
            )}
          </>
        )}
      </div>
    </section>
  );
};


InstallDiagram.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  buttontext: PropTypes.string,
  buttonurl: PropTypes.string,
  buttondescription: PropTypes.string,
};

export default InstallDiagram;
